import ErrorBgEn from 'assets/images/notFoundEn.svg';
import ErrorBgFr from 'assets/images/notFoundFr.svg';

import { useTranslation } from 'react-i18next';

import { Box, Typography, Button } from '@mui/material';

import { stylesError, stylesErrorTitle, stylesErrorContent } from '@/utils/globalStyles';

export function NotFound() {
  const { t, i18n } = useTranslation('components');
  return (
    <Box
      sx={{ ...stylesError, backgroundImage: `url(${i18n.language === 'fr' ? ErrorBgFr : ErrorBgEn})` }}
      role='alert'
    >
      <Box component='h1' sx={stylesErrorTitle}>
        {t('notFound.title')}
      </Box>
      <Typography variant='h1' component='p'>
        {t('notFound.subtitle')}
      </Typography>
      <Typography variant='bodyXL' component='p' sx={stylesErrorContent}>
        {t('notFound.content')}
      </Typography>
      {/* TODO : Faire le lien */}
      <Button onClick={() => window.location.assign(window.location.origin)}>{t('notFound.back')}</Button>
      <br />
      {/* TODO : Faire le lien vers la liste des dossiers */}
      <Button href='/folders'>{t('notFound.folders')}</Button>
    </Box>
  );
}
